/**
 * Admin Configuration
 * Centralized configuration for admin settings
 */

export const ADMIN_CONFIG = {
  // Admin credentials from environment variables
  credentials: {
    username: import.meta.env.VITE_ADMIN_USERNAME || 'admin',
    email: import.meta.env.VITE_ADMIN_EMAIL || 'akiblackcar@gmail.com',
    // Password is managed dynamically by adminPasswordService
  },

  // Security settings
  security: {
    maxLoginAttempts: 5,
    lockoutDuration: 15 * 60 * 1000, // 15 minutes
    sessionTimeout: 24 * 60 * 60 * 1000, // 24 hours
    passwordResetTokenExpiry: 15 * 60 * 1000, // 15 minutes
  },

  // Email settings
  email: {
    serviceUrl: import.meta.env.VITE_EMAIL_SERVICE_URL,
    apiKey: import.meta.env.VITE_EMAIL_API_KEY,
    fromAddress: import.meta.env.VITE_ADMIN_EMAIL || 'akiblackcar@gmail.com',
    companyName: 'Horizons Black Car Service',
  },

  // Database settings (if using database)
  database: {
    url: import.meta.env.VITE_DATABASE_URL,
    key: import.meta.env.VITE_DATABASE_KEY,
  },

  // Feature flags
  features: {
    enablePasswordReset: true,
    enableTwoFactorAuth: false, // Can be enabled later
    enableEmailNotifications: true,
    enableAuditLogging: true,
  },

  // Development settings
  development: {
    showResetLinksInConsole: import.meta.env.VITE_DEBUG_MODE === 'true',
    mockEmailSending: import.meta.env.NODE_ENV === 'development',
  }
};

export default ADMIN_CONFIG;
